import { z } from 'zod';

export const selectFilterValidationSchema = z
  .tuple([z.enum(['eq', 'neq']), z.union([z.null(), z.boolean()])])
  .catch(['eq', null]);

export const multiSelectFilterValidationSchema = z
  .tuple([z.enum(['in', 'nin']), z.array(z.string())])
  .catch(['in', []]);

export const rangeFilterValidationSchema = z
  .tuple([
    z.enum(['in_range', 'nin_range']),
    z.tuple([z.union([z.number(), z.null()]), z.union([z.number(), z.null()])]),
  ])
  .catch(['in_range', [null, null]]);
